import React, { useReducer } from 'react'
import BulkContext from './bulkContext'
import BulkReducer from './bulkReducer'
import { apiCall } from '@/product//common/api'
import { response } from '@/product//context/common'
import { GET_SAMPLE_FILE, CLEAR_RESPONSE, RESPONSE_STATUS } from './bulkTypes'

const BulkState = (props) => {
    const initialState = {
        sample_file: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(BulkReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllSampleDownload = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'export_xlsx', formData, '', 'custom/front/report'),
            ])
            let fromValue = from || 'sampleReport'
            if (res.data.status === 'success') {
                console.log(res.data, fromValue, 'resSuccess')
                resp.commonResponse(res.data, fromValue)
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromValue)
            } else {
                resp.commonErrorResponse(fromValue)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const uploadBulkFile = async (formData, fromVariable) => {
        try {
            const from = fromVariable || 'uploadAssetFile'
            const [res] = await Promise.all([
                apiCall('post', 'uploadAssetFile', formData, '', 'front/report', true),
            ])
            console.log(res, 'reff')

            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <BulkContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                // search_allauctions: state.search_allauctions,
                // search_all_pastauction: state.search_all_pastauction,
                responseStatus: state.responseStatus,
                // search_alldashboardauctions: state.search_alldashboardauctions,
                // all_user_agreement: state.all_user_agreement,
                clearResponse,
                getAllSampleDownload,
                uploadBulkFile,
            }}
        >
            {props.children}
        </BulkContext.Provider>
    )
}

export default BulkState
